// Vignettes des pages (étape 7) : pdfjs-dist ne fournit pas de composant de vignettes.
// À programmer : dessin de chaque page en petit au fil du défilement (IntersectionObserver),
// surlignage de la page courante avec l'événement « pagechanging », bouton .pdf-bouton--vignettes
// (aria-pressed) et panneau .pdf-vignettes à afficher.
export function initialiserVignettes(/* section, { viewer, eventBus, pdf } */) {}
